<template>
    <div>
        <button v-for="question in questions"
                class="btn btn--link faq__item"
                @click="openAnswer(question)">
            {{ question.answer_title }}
        </button>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {store} from "../../../store/faq";

    export default {
        name: "Questions",
        store,
        props: ['questions'],
        methods: {
            ...mapActions([
                'openAnswer',
            ]),
        },
    }
</script>